module.exports = __webpack_public_path__ + "static/media/post_1500.95429d09.glb";